// @flow

export const TRACKING_EVENTS = {
  AUTH_CONFIG_STARTED:
    'Track: Visual Builder - Authentication configuration started',
  NEW_ACTION_STARTED: 'Track: Visual Builder - Action configuration started',
  NEW_TRIGGER_STARTED: 'Track: Visual Builder - Trigger configuration started',
  FAILED_MERGE: 'Track: Failed UI Merge',
  SUCCESSFUL_MERGE: 'Track: Successful UI Merge',
};
